import React, { useEffect } from 'react';
import './styles/section-typography.css';
import './styles/responsive.css';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import SiteNavbar from './components/SiteNavbar';
import Footer from './components/footer';
import AppRoutes from './routes/AppRoutes';
import ScrollToTopButton from './components/ScrollToTopButton';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ScrollTop from './components/ScrollTop';

const STANDALONE_PATHS = ['/landing', '/thank-you-aggregator', '/aggregator/thank-you'];

// ✅ Component to track page views
const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if Meta Pixel is loaded
    if (window.fbq) {
      window.fbq('track', 'PageView');
      window.fbq('track', 'ViewContent', {
        page_path: location.pathname
      });
    }
  }, [location]);

  return null;
};

const AppLayout = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isStandalone = STANDALONE_PATHS.includes(location.pathname);

  return (
    <>
      <MetaPixelTracker />

      {!isStandalone && <ScrollTop />}
      {!isStandalone && <ScrollToTopButton />}
      {!isStandalone && <FloatingWhatsApp />}
      {!isStandalone && <SiteNavbar />}
      <div className={isHome || isStandalone ? undefined : 'app-page-offset'}>
        <AppRoutes />
      </div>
      {!isStandalone && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
};

export default App;
